import React, { useState } from "react";
import './Checkout1.css'
import { useLocation } from "react-router-dom";
const Checkout = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        mobile: "",
        address: "",
        zip: ""
    });
    const [selectedDate, setSelectedDate] = useState("");
    const [selectedTime, setSelectedTime] = useState("");
    const location = useLocation();
    const cart = location.state?.cart || [];
    const getDateOptions = () => {
        const options = [];
        const today = new Date();
        for (let i = 0; i < 7; i++) {
            const date = new Date();
            date.setDate(today.getDate() + i);
            options.push({
                day: date.toLocaleString('en-US', { weekday: 'short' }),
                date: date.toLocaleDateString()
            });
        }
        return options;
    };

    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setFormData({ ...formData, [id]: value });
    };

    const handlePayment = (e) => {
        e.preventDefault();
        // Navigate to Google Play Store
        window.open('https://play.google.com/store/apps/details?id=com.cleanto.astraclean', '_blank');
    };

    const calculateTotal = () => {
        return cart.reduce((total, item) => total + item.discountedPrice * item.qty, 0).toFixed(2);
    };
    return (
        <div className="checkout-container">
            <h1 className="checkout-title">Checkout</h1>
            <div className="checkout-row">
                <div className="checkout-col-summary">
                    <div className="order-summary">
                        <h2>Order Summary</h2>
                        <p>Products ({cart.length}) <span>Rs.{calculateTotal()}</span></p>
                        <h3>Total Amount <span>Rs.{(parseFloat(calculateTotal())).toFixed(2)}</span></h3>
                    </div>
                </div>
                <div className="billing-address-section form-section">

                    <h3>Billing Address</h3>
                    <form onSubmit={handlePayment}>
                        <div className="form-group">
                            <input type="text" className="form-control" id="name" required placeholder="Enter Your Name" value={formData.name} onChange={handleInputChange} />
                        </div>
                        <div className="form-group">
                            <input type="email" className="form-control" id="email" required placeholder="Enter Your Email" value={formData.email} onChange={handleInputChange} />
                        </div>
                        <div className="form-group">
                            <input type="number" className="form-control" id="mobile" required placeholder="Contact Number" value={formData.mobile} onChange={handleInputChange} />
                        </div>
                        <div className="form-group">
                            <input type="text" className="form-control" id="address" required placeholder="Enter Your Address" value={formData.address} onChange={handleInputChange} />
                        </div>
                        <div className="form-group">
                            <input type="text" className="form-control" id="zip" required placeholder="Zip Code" value={formData.zip} onChange={handleInputChange} />
                        </div>

                        <div className="date-time-group">
                            <h3>Select Date of Service</h3>
                            <div className="date-options">
                                {getDateOptions().map((dateOption, index) => (
                                    <button
                                        key={index}
                                        type="button"
                                        className={`date-btn ${selectedDate === dateOption.date ? 'selected' : ''}`}
                                        onClick={() => setSelectedDate(dateOption.date)}
                                    >
                                        {dateOption.day} {dateOption.date}
                                    </button>
                                ))}
                            </div>
                            <h3>Select Start Time of Service</h3>
                            <div className="time-options">
                                {["8:00 AM", "8:30 AM", "9:00 AM", "9:30 AM", "10:00 AM", "10:30 AM", "11:00 AM", "11:30 AM", "12:00 PM", "12:30 PM", "1:00 PM", "1:30 PM", "2:00 PM", "2:30 PM", "3:00 PM", "3:30 PM", "4:00 PM", "4:30 PM", "5:00 PM", "5:30 PM", "6:00 PM", "6:30 PM", "7:00 PM", "7:30 PM"].map((time, index) => (
                                    <button
                                        key={index}
                                        type="button"
                                        className={`time-btn ${selectedTime === time ? 'selected' : ''}`}
                                        onClick={() => setSelectedTime(time)}
                                    >
                                        {time}
                                    </button>
                                ))}
                            </div>
                        </div>
                        <button type="submit" className="checkout-btn-primary">Proceed to Payment</button>
                    </form>
                </div>
            </div>

        </div>
    );
};

export default Checkout;
